<!-- START JUMBOTRON -->
<div data-pages="parallax">
  <div class="container-fluid p-3">
    <div class="inner">
      <!-- START BREADCRUMB -->
      <ol class="breadcrumb sm-p-b-5">
        <li class="breadcrumb-item">
          <a href="javascript:void(0)">Home</a>
        </li>
        <li class="breadcrumb-item active">Dashboard</li>
      </ol>
    </div>
  </div>
</div>
<!-- END JUMBOTRON -->
<!-- START CONTAINER FLUID -->
<div class="container-fluid p-3">
  <!-- START ROW -->
  <div class="row">
    <div class="col-lg-3 col-sm-6  d-flex flex-column">
      <!-- START WIDGET -->
      <!-- START ITEM -->
      <pgcardsocial Type="widget" AdditionalClasses="full-width m-b-10 no-border" Title="Update" TitleClass="text-success" Comments="5,345"
        Body="page dashboard Version 3.0 now release with limitless layout possibilities" Source="Pages" Timestamp="Jul 24">
      </pgcardsocial>
      <!-- END ITEM -->
      <!-- END WIDGET -->
      <!-- START WIDGET -->
      <weekly-sales-widget></weekly-sales-widget>
      <!-- END WIDGET -->
      <!-- START WIDGET -->
      <quick-stats-widget></quick-stats-widget>
      <!-- END WIDGET -->
    </div>
    <div class="col-lg-3 col-sm-6  d-flex flex-column">
      <!-- START ITEM -->

      <pgcardsocial Type="widget" AdditionalClasses="full-width m-b-10 no-border" Title="Stock Market" TitleClass="text-success"
        Comments="5,345" Source="John Smith" Timestamp="Apr 24">
        <ng-template #CustomBody>
          <h5 class='no-margin'>Apple Inc.</h5>
          <h5 class="small hint-text no-margin">NASDAQ: AAPL - Nov 13 8:37 AM ET</h5>
          <h3 class="m-b-0">111.25
            <span class="text-success">
              <i class="fa fa-sort-up small text-success"></i> 0.15</span>
          </h3>
        </ng-template>
      </pgcardsocial>
      <!-- END ITEM -->
      <!-- @TODO : USE HTML FOR NOW  - START ITEM -->
      <div class="card social-card share share-other full-width m-b-10 d-flex flex-1 no-border sm-vh-75" >
          <div class="circle">
          </div>
          <div class="card-content flex-1" data-pages-bg-image [ngStyle]="{'background-image':'url(assets/img/dashboard/social_new.jpg)'}">
            <ul class="buttons ">
              <li>
                <a href="#"> <i class="pg-icon">expand</i>
                </a>
              </li>
              <li>
                <a href="#"><i class="pg-icon">heart</i>
                </a>
              </li>
            </ul>
          </div>
          <div class="card-description">
            <p><a href="#">#TBT</a> :D</p>
          </div>
          <div class="card-footer clearfix">
            <div class="time">few seconds ago</div>
            <ul class="reactions">
              <li><a href="#" class="d-flex align-items-center">5,345 <i class="pg-icon">comment</i></a>
              </li>
              <li><a href="#" class="d-flex align-items-center">23K <i class="pg-icon">heart</i></a>
              </li>
            </ul>
          </div>
          <div class="card-header clearfix">
            <div class="user-pic">
                <img alt="Avatar" width="33" height="33" pgRetina src2x="assets/img/profiles/avatar_small2x.jpg" src1x="assets/img/profiles/avatar.jpg"
                src="assets/img/profiles/avatar_small2x.jpg">
            </div>
            <h5>David Nester</h5>
            <h6>Shared a link on your wall</h6>
          </div>
      </div>
      <!-- END ITEM -->
    </div>
    <div class="col-lg-6 m-b-10 d-flex">
      <!-- START WIDGET -->
      <table-widget></table-widget>
      <!-- END WIDGET -->
    </div>
  </div>
  <!-- END ROW -->
  <!-- START ROW -->
  <div class="row">
    <div class="col-lg-4 md-m-b-10">
      <!-- START WIDGET -->
      <project-progress-widget></project-progress-widget>
      <!-- END WIDGET -->
    </div>
    <div class="col-lg-8 sm-m-t-10">
      <!-- START WIDGET -->
      <map-widget></map-widget>
      <!-- END WIDGET -->
    </div>
  </div>
  <!-- END ROW -->
</div>
<!-- END CONTAINER FLUID -->
